import { fetchWrapper } from './fetch-wrapper';
import { urls } from '@/urls';

export async function uploadPhoto(file: File): Promise<{ url: string; blobName?: string }> {
  const form = new FormData();
  form.append('file', file);
  return await fetchWrapper.postForm(urls.DevOps.uploadPhoto, form);
}

export const getPhotoUploadUrl = async (fileOrUrl: string) => {
  const value = String(fileOrUrl ?? '').trim();
  if (!value) return '';
  if (value.startsWith('http://') || value.startsWith('https://')) return value;
  const res = await fetchWrapper.get(urls.DevOps.blobUrl(value));
  return res.url as string;
};

// Backwards-compatible name used throughout the app.
export default async function uploadFileToBlob(file: File) {
  return await uploadPhoto(file);
}
